import { useEffect } from 'react'

/**
 * Custom hook to manage document title
 * @param title - The title to set (without the "| Zehnlabs Fintech" suffix)
 * @param deps - Optional dependencies array to trigger title updates
 */
export const useDocumentTitle = (title: string, deps: React.DependencyList = []) => {
  useEffect(() => {
    const fullTitle = title.includes('|') ? title : `${title} | Zehnlabs Fintech`
    document.title = fullTitle
  }, [title, ...deps])
}

/**
 * Utility function to format strategy names for titles
 * @param strategyName - The strategy name to format (e.g., "my-strategy-name")
 * @returns Formatted strategy name (e.g., "My Strategy Name")
 */
export const formatStrategyName = (strategyName: string): string => {
  return strategyName
    .replace('etf-blend-', 'ETF Blend ')
}